import {useState} from 'react'
import {Groups} from './Groups'
import {Link} from 'react-router-dom'
import {SearchBarProvider, SectionSearchBarContext} from './SearchBar'
import {Devices} from './Devices'
import {People} from './People'
import { ErrorBoundary } from '@sentry/react'

export const Tabs = [
  {name: 'Groups', Component: Groups},
  {name: 'Devices', Component: Devices},
  {
    name: 'People',
    Component: People,
    props: {}
  }
]

const Fallback = () => {
  return <div className="d-flex justify-content-center align-items-center m-4 p-5 border rounded">
    <div className="opacity-50 text-center">
      <h5 className="m-0 p-0">
        <i className="fa fa-exclamation-triangle mr-2"></i> We are experiencing problem!
        <p className="m-0 p-0 mt-2"><small>The problem has been identified and reported already, We are doing our best to resolve the issue.</small></p>
      </h5>
    </div>
  </div>
}

export const Sections = props => {
  const {allowActions, business} = props
  const [activeTab, setActiveTab] = useState(0)

  const Tab = Tabs[activeTab]

  return (
    <div className="table-responsive-mask">
      <div className="vw-type-menu-wrapper vw-tab-menu-wrapper tab">
        <nav className="vw-type-menu vw-tab-menu">
          <ul>
            {Tabs.map((tab, index) => (
              <li key={index}>
                <Link
                  className={activeTab === index ? 'active' : ''}
                  onClick={() => setActiveTab(index)}
                >
                  {tab.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <SearchBarProvider>
        <ErrorBoundary fallback={<Fallback />}>
          <Tab.Component
            SearchContext={SectionSearchBarContext}
            allowActions={allowActions}
            business={business}
          />
        </ErrorBoundary>

        {/* <Routes>
              <Route path="/" element={<Groups />} />
              <Route path="groups" element={<Groups/>} />
              <Route path="devices" element={<Devices/>} />
              <Route path="people" element={<People/>} />
            </Routes> */}

        {/* {
              activeTab === 'devices' && <Connect
                Component={Devices}
                SearchContext={SectionSearchBarContext}
                service="device"
                params={params}
                config={{ query: { business: id }}}
              />
            }

            {
              activeTab === 'people' && <Connect
                Component={People}
                SearchContext={SectionSearchBarContext}
                service="user"
                params={params}
                config={{ query: {
                  business: id,
                  $populate: [
                    'device',
                    'business',
                    'reseller',
                    'distributor',
                    'adminOf'
                  ]
                }}}
              />
            } */}
      </SearchBarProvider>
    </div>
  )
}
